import axios from "axios";
const FormData = require('form-data');
const fs = require('fs');


const freshdeskUrl = "https://playo.freshdesk.com/api/v2/";
const FRESHDESK_API_KEY = "Sfh5QAESzTDqkqvPc2f"
// const playoUrl = "https://playo.io";

const playoUrl = "https://playo.info";
// const categoryId = 360000495093;
const requestPerPage = 10;
const localeId = 1278;
// const userName = "Amit Roushan";
// const userEmail = "akroushan@gmail.com";

axios.defaults.headers.common["Authorization"] =
  "Bearer 8819ecf51ea6209b4690ba4149b1d424815ef906dd70ba1dfa32e5f505704cfd";

var api = {
  displayMainLoader: function () {
    document.getElementsByClassName("loader-screen")[0].style.display = "block";
  },
  displayHideLoader: function () {
    document.getElementsByClassName("loader-screen")[0].style.display = "none";
  },

  getUserData: function (userId) {
    return new Promise((resolve, reject) => {
      axios({
        method: "get",
        url: `${playoUrl}/api/v2/user/${userId}/?isAppUser=1`,
        headers: {
          Authorization: "5534898698eb3426d00168b6ed447d23d000026552ed6200",
          "Content-Type": "application/json",
        },
      })
        .then((response) => {
          const data = response.data;
          const { requestStatus } = data;
          if (requestStatus === 1) {
            resolve(data.user);
          } else {
            reject(data.message);
          }
        })
        .catch(function (error) {
          reject(error);
        });
    });
  },
  getUserDataV2: function (userId) {
    return new Promise((resolve, reject) => {
      axios({
        method: "get",
        url: `https://api.playo.io/user/info/${userId}`,
        headers: {
          Authorization: "5534898698eb3426d00168b6ed447d23d000026552ed6200",
          "Content-Type": "application/json",
        },
      })
        .then((response) => {
          const data = response.data;
          const { requestStatus } = data;
          if (requestStatus === 1) {
            resolve(data.userInfo);
          } else {
            reject(data.message);
          }
        })
        .catch(function (error) {
          reject(error);
        });
    });
  },
  updateUserData: function (data) {
    return new Promise((resolve, reject) => {
      axios({
        method: "post",
        url: `https://api.playo.io/user/profile/update`,
        data,
        headers: {
          Authorization: "5534898698eb3426d00168b6ed447d23d000026552ed6200",
          "Content-Type": "application/json",
        },
      })
        .then((response) => {
          const data = response.data;
          const { requestStatus } = data;
          if (requestStatus === 1) {
            resolve(data.user);
          } else {
            reject(data.message);
          }
        })
        .catch(function (error) {
          reject(error);
        });
      });
    },
    updateUserDatav2: function (data) {
      return new Promise((resolve, reject) => {
        axios({
          method: "post",
          url: `https://api.playo.io/user/profile/update`,
          data,
          headers: {
            Authorization: "5534898698eb3426d00168b6ed447d23d000026552ed6200",
            "Content-Type": "application/json",
          },
        })
        .then((response) => {
          const data = response.data;
          const { requestStatus } = data;
          if (requestStatus === 1) {
            resolve(data.profileInfo);
          } else {
            reject(data.message);
          }
        })
        .catch(function (error) {
          reject(error);
        });
    });
  },
  categoriesWiseList: function (page, categoryId) {
    return new Promise((resolve, reject) => {
      let apiUrl = `${freshdeskUrl}solutions/categories/1070000183081/folders`;
      axios({
        method: "get",
        url: apiUrl,
        auth: {
          username: FRESHDESK_API_KEY,
          password: 'X'
        }
      })
        .then(function (response) {
          resolve(response);
        })
        .catch(function (error) {
          reject(error);
        });
    });
  },
  displayArticleDetails: function (articleId) {
    return new Promise((resolve, reject) => {
      let apiUrl = freshdeskUrl + "solutions/articles/" + articleId;
      axios({
        method: "get",
        url: apiUrl,
        auth: {
          username: 'aCjP5qKz71YRWZ5n10nG',
          password: 'X'
        }
      })
        .then(function (response) {
          resolve(response);
        })
        .catch(function (error) {
          reject(error);
        });
    });
  },
  articlesInSections: function (sectionId, page) {
    if (page >= 0) {
      return new Promise((resolve, reject) => {
        let apiUrl =
          freshdeskUrl +
          "solutions/folders/" +
          sectionId
          + "/articles";
        axios({
          method: "get",
          url: apiUrl,
          crossDomain: true,
          auth: {
            username: FRESHDESK_API_KEY,
            password: 'X'
          }
        })
          .then(function (response) {
            resolve(response);
          })
          .catch(function (error) {
            reject(error);
          });
      });
    }
  },
  displayArticleDetails: function (articleId) {
    return new Promise((resolve, reject) => {
      let apiUrl = freshdeskUrl + "solutions/articles/" + articleId;
      axios({
        method: "get",
        url: apiUrl,
        auth: {
          username: FRESHDESK_API_KEY,
          password: 'X'
        }
      })
        .then(function (response) {
          resolve(response);
        })
        .catch(function (error) {
          reject(error);
        });
    });
  },
  searchBasedOnCategory: function (searchKey, page, categoryId) {
    return new Promise((resolve, reject) => {
      let apiUrl =
        freshdeskUrl +
        "search/solutions?term=" +
        searchKey;
      axios({
        method: "get",
        url: apiUrl,
        auth: {
          username: FRESHDESK_API_KEY,
          password: 'X'
        }
      })
        .then(function (response) {
          resolve(response);
        })
        .catch(function (error) {
          reject(error);
        });
    });
  },
  createNewTicket: function (
    dataInJson,
    userId,
    email,
    name,
    mobile,
    city,
    countryCode,
    reportedId = null,
    deleteRequest = false,
    guestId = null
  ) {
    const customFields = {
      "cf_user_phone_number": `${countryCode} ${mobile}`,
      "cf_user_id": userId,
      "cf_city": city,
      "cf_user_name": name
    };
    const tags = [];
    if (reportedId) {
      //customFields.push({"reporterId": reportedId });
      tags.push("report-abuse");
    }

    if (deleteRequest) {
      tags.push("delete-account");
    }
    return new Promise((resolve, reject) => {
      const description = `${dataInJson.description} \n\n Account Details: \n ${name} | ${email} | ${mobile}`;
      const updatedDescription = `
        --------------------------------------------------------------------------------------------------\n\n
        ${description}
        --------------------------------------------------------------------------------------------------\n\n
      `;
      let ticketObj = {
        ticket: {
          subject: dataInJson.title,
          description: updatedDescription,
          custom_fields: customFields,
          cc_emails: ["zendesk@playo.co"],
          unique_external_id: userId,
          tags: tags,
          status: 2,
          priority: 1,
          source: 2
        },
      };

      if (email) {
        //ticketObj.ticket.locale_id = localeId
        ticketObj.ticket.name = name
        ticketObj.ticket.email = email
        ticketObj.ticket.phone = `${countryCode} ${mobile}`
      } else {
        /**
         * Zendesk doesn't let create tickets for users without email, so on behalf of those users, we use this user
         * which is registered on zendesk as an end user and has email - mehuli.zendesk@playo.co
         */
        ticketObj.ticket.submitter_id = 21703493142169;
      }

      let apiUrl = freshdeskUrl + "tickets";
      axios({
        method: "post",
        url: apiUrl,
        data: ticketObj.ticket,
        auth: {
          username: FRESHDESK_API_KEY,
          password: 'X'
        }
      })
        .then(function (response) {
          resolve(response);
        })
        .catch(function (error) {
          reject(error);
        });
    });
  },
  createNewTicketWithAttachments: function (
    dataInJson,
    userId,
    email,
    name,
    mobile,
    city,
    countryCode,
    reportedId = null,
    deleteRequest = false,
    guestId = null
  ) {
    const tags = [];
    if (reportedId) {
      //customFields.push({"reporterId": reportedId });
      tags.push("report-abuse");
    }

    if (deleteRequest) {
      tags.push("delete-account");
    }

    const formData = new FormData();
    return new Promise((resolve, reject) => {
      const description = `${dataInJson.description} \n\n Account Details: \n ${name} | ${email} | ${mobile}`;
      const updatedDescription = `
        --------------------------------------------------------------------------------------------------\n\n
        ${description}
        --------------------------------------------------------------------------------------------------\n\n
      `;
      formData.append("custom_fields[cf_user_phone_number]", `${countryCode} ${mobile}`)
      formData.append("custom_fields[cf_user_id]", userId)
      formData.append("custom_fields[cf_city]", city)
      formData.append("custom_fields[cf_user_name]", name)
      formData.append("subject", dataInJson.title)
      formData.append("description", updatedDescription)
      formData.append("cc_emails[]", ["zendesk@playo.co"])
      formData.append("unique_external_id", userId)
      formData.append("tags[]", tags)
      formData.append("status", 2)
      formData.append("priority", 1)
      formData.append("source", 2)
      console.log(dataInJson.imageArray)

      dataInJson.imageArray.forEach((file, index) => {
        formData.append(`attachments[]`, file)
      })

      if (email) {
        // ticketObj.ticket.locale_id = localeId
        formData.append("name", name)
        formData.append("email", email)
        formData.append("phone", `${countryCode} ${mobile}`)
      } else {
        /**
         * Zendesk doesn't let create tickets for users without email, so on behalf of those users, we use this user
         * which is registered on zendesk as an end user and has email - mehuli.zendesk@playo.co
         */
        formData.append("submitter_id", 21703493142169);
      }

      let apiUrl = freshdeskUrl + "tickets";
      axios({
        method: "post",
        url: apiUrl,
        data: formData,
        headers: {
          "Content-Type": `multipart/form-data;`, boundary: formData._boundary
        },
        auth: {
          username: FRESHDESK_API_KEY,
          password: 'X'
        }
      })
        .then(function (response) {
          resolve(response);
        })
        .catch(function (error) {
          console.log(error)
          reject(error);
        });
    });
  },
  listOfTickets: function (page, userId) {
    return new Promise((resolve, reject) => {
      let apiUrl =
        freshdeskUrl +
        "tickets?unique_external_id=" + userId +
        // userId +
        "&order_by=updated_at&order_type=desc&page=" +
        page +
        "&per_page=" +
        requestPerPage;
      axios({
        method: "get",
        url: apiUrl,
        auth: {
          username: FRESHDESK_API_KEY,
          password: 'X'
        }
      })
        .then(function (response) {
          resolve(response);
        })
        .catch(function (error) {
          reject(error);
        });
    });
  },
  getTicketStatusAndTitle: function (ticketId) {
    return new Promise((resolve, reject) => {
      let apiUrl = freshdeskUrl + "tickets/" + ticketId + "?include=requester";
      axios({
        method: "get",
        url: apiUrl,
        auth: {
          username: FRESHDESK_API_KEY,
          password: 'X'
        }
      })
        .then(function (response) {
          resolve(response);
        })
        .catch(function (error) {
          reject(error);
        });
    });
  },
  ticketsDetails: function (ticketId, nextPage) {
    return new Promise((resolve, reject) => {
      let apiUrl = freshdeskUrl + "tickets/" + ticketId + "?include=requester";
      if (nextPage != null) {
        apiUrl = nextPage;
      }
      axios({
        method: "get",
        url: apiUrl,
        auth: {
          username: FRESHDESK_API_KEY,
          password: 'X'
        }
      })
        .then(function (response) {
          resolve(response);
        })
        .catch(function (error) {
          reject(error);
        });
    });
  },
  conversations: function (ticketId, nextPage) {
    return new Promise((resolve, reject) => {
      let apiUrl = freshdeskUrl + "tickets/" + ticketId + "/conversations";
      if (nextPage != null) {
        apiUrl = nextPage;
      }
      axios({
        method: "get",
        url: apiUrl,
        auth: {
          username: FRESHDESK_API_KEY,
          password: 'X'
        }
      })
        .then(function (response) {
          resolve(response);
        })
        .catch(function (error) {
          reject(error);
        });
    });
  },
  addNote: function (ticketId, dataInJson) {
    return new Promise((resolve, reject) => {
      let ticketObj = {
        ticket: {
          user_id: parseInt(dataInJson.user_id),
          private: false,
          incoming: true,
          body: dataInJson.comment,
        },
      };
      let apiUrl = freshdeskUrl + "tickets/" + ticketId + "/notes";
      axios({
        method: "post",
        url: apiUrl,
        data: ticketObj.ticket,
        auth: {
          username: FRESHDESK_API_KEY,
          password: 'X'
        }
      })
        .then(function (response) {
          resolve(response);
        })
        .catch(function (error) {
          reject(error);
        });
    });
  },
  addNoteWithAttachments: function (ticketId, dataInJson) {
    console.log(dataInJson)
    const formData = new FormData();
    formData.append("user_id", dataInJson.user_id)
    formData.append("private", false)
    formData.append("incoming", true)
    formData.append("body", dataInJson.comment)
    dataInJson.imageArray.forEach((file, index) => {
      formData.append(`attachments[]`, file)
    })

    return new Promise((resolve, reject) => {
      let apiUrl = freshdeskUrl + "tickets/" + ticketId+"/notes";
      axios({
        method: "post",
        url: apiUrl,
        data: formData,
        headers: {
          "Content-Type": `multipart/form-data;`, boundary: formData._boundary
        },
        auth: {
          username: FRESHDESK_API_KEY,
          password: 'X'
        }
      })
        .then(function (response) {
          resolve(response);
        })
        .catch(function (error) {
          reject(error);
        });
    });

  },
  updateTicket: function (ticketId, dataInJson) {
    return new Promise((resolve, reject) => {
      let ticketObj = {
        ticket: {
          status: dataInJson.status,
          type: "User Requested Closure",
          custom_fields: dataInJson.customFields,
          unique_external_id: dataInJson.customFields.cf_user_id
        },
      };
      let apiUrl = freshdeskUrl + "tickets/" + ticketId;
      axios({
        method: "put",
        url: apiUrl,
        data: ticketObj.ticket,
        auth: {
          username: FRESHDESK_API_KEY,
          password: 'X'
        }
      })
        .then(function (response) {
          resolve(response);
        })
        .catch(function (error) {
          reject(error);
        });
    });
  }
};

export default api;



// WEBPACK FOOTER //
// ./src/api/api.js